import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const useAppLayout = () => {
  const navigate = useNavigate();
  axios.defaults.withCredentials = true;

  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [showSidebar, setShowSidebar] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
    setShowSidebar(!showSidebar);
  };

  return {
    navigate,
    isSidebarVisible,
    showSidebar,
    toggleSidebar,
  };
};

export default useAppLayout;